/** 我的作業(homework.html)進入點。 */
import '../loading';
import { initStudentPage } from '../dashboard';
import { initHomework } from '../homework';

void (async () => {
  await initStudentPage();
  await initHomework();
})();
